module.exports = __webpack_public_path__ + "img/block-375.da836e87.jpg";